import React, { useEffect, useState } from "react";
import "../index.css";
import { Button } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import Typography from "@material-ui/core/Typography";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { makeStyles } from "@material-ui/core/styles";
import {
  Select,
  MenuItem,
  TextField,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import { useHistory, useRouteMatch } from "react-router-dom";
import http from "../services/httpService";
import toast, { Toaster } from "react-hot-toast";
import { addEditProspect } from "../utils/validations";
import handleValidation from "../utils/handleValidations";
import handleSubmitValidation from "../utils/handleSubmitValidation";
import { vantagePath, getToday } from "../utils/varialbles";
import { ArrowDownward, ArrowDropDown, ArrowDropUp } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    paddingTop: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  submitButton: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(10),
  },
  gridDevider: {
    marginTop: theme.spacing(6),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  lableColor: {
    color: "#393939",
    paddingTop: "5px",
  },
  select: {
    height: 36,
    minWidth: 235,
  },
  mobileCode: {
    height: 36,
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },

  checked: {},
}));
function AddProspect() {
  let history = useHistory();
  const [questionner, setQuestionner] = useState([]);
  const [mobileNumberDuplicate, setmobileNumberDuplicate] = useState(false);
  const [mobileNumberLength, setmobileNumberLength] = useState(false);
  const [mobileNumberPattern, setmobileNumberPattern] = useState(false);
  const [mobileTestPass, setmobileTestPass] = useState(true);
  const [emailDuplicate, setemailDuplicate] = useState(false);
  const [emailPattern, setemailPattern] = useState(false);
  const [emailTestPass, setemailTestPass] = useState(true);
  const [countryDropDown, setcountryDropDown] = useState([]);
  const [taskType, setTaskType] = useState([]);
  const [language, setLanguage] = useState([]);
  const [prospectType, setProspectType] = useState([]);
  let form = {
    mobile: "",
    countrycode: "91",
    fname: "",
    lname: "",
    email: "",
    rm: "",
    language: "",
    type: "",
    signupfrom: "",
    selected_tags: "",
    // "reason": "",
    // "getbackdate": "",
    // "status": "",
    // "comment": "",
    // "enquiry": "",
    // "communication": "",
    // "interest": "",
    // "reason_notinterest": "",
    // "politeness": "",
    // "family_background": "",
    // "goal": "",
    // "previous_investment": "",
    // "inv_exp": "",
    // "broker_quantum": "",
    // "advisor_quantum": "",
    // "loc_state": "",
    // "loc_country": ""
  };
  const validations = {
    mobile: {
      conditions: {
        required: true,
      },
      message: "This feild is required!",
      valid: true,
      changed: false,
    },
    language: {
      conditions: {
        required: true,
      },
      message: "This feild is required!",
      valid: true,
      changed: false,
    },
    type: {
      conditions: {
        required: true,
      },
      message: "This feild is required!",
      valid: true,
      changed: false,
    },

    fname: {
      conditions: {
        required: false,
        maxLength: 20,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
    lname: {
      conditions: {
        required: false,
        maxLength: 20,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
    comment: {
      conditions: {
        required: false,
        maxWordLength: 500,
        delimiter: " ",
      },
      message: "Maximum 500 Words Allowed.!",
      valid: true,
      changed: false,
    },
    reason_notinterest: {
      conditions: {
        required: false,
        maxWordLength: 100,
        delimiter: " ",
        conditionalRequired: true,
        conditionValue: 2,
        conditionField: "interest",
        conditionOperator: "eq",
        conditionFieldValue: null,
      },
      message: "Maximum 100 Words Allowed.!",
      valid: true,
      changed: false,
    },
    family_background: {
      conditions: {
        required: false,
        maxWordLength: 100,
        delimiter: " ",
      },
      message: "Maximum 100 Words Allowed.!",
      valid: true,
      changed: false,
    },
    goal: {
      conditions: {
        required: false,
        maxWordLength: 100,
        delimiter: " ",
      },
      message: "Maximum 100 Words Allowed.!",
      valid: true,
      changed: false,
    },
    // ,
    // "previous_investment":{
    //     conditions: {
    //         "required": true,
    //     }, "message": "This feild is required!", "valid": true, "changed": false
    // },
    inv_exp: {
      conditions: {
        required: false,
        maxWordLength: 100,
        delimiter: " ",
        conditionalRequired: true,
        conditionValue: 4,
        conditionField: "previous_investment",
        conditionOperator: "neq",
        conditionFieldValue: null,
      },
      message: "Maximum 100 Words Allowed.!",
      valid: true,
      changed: false,
    },
    broker_quantum: {
      conditions: {
        required: false,
        maxWordLength: 100,
        delimiter: " ",
        conditionalRequired: true,
        conditionValue: 4,
        conditionField: "previous_investment",
        conditionOperator: "neq",
        conditionFieldValue: null,
      },
      message: "Maximum 100 Words Allowed.!",
      valid: true,
      changed: false,
    },
    advisor_quantum: {
      conditions: {
        required: false,
        maxWordLength: 100,
        delimiter: " ",
        conditionalRequired: true,
        conditionValue: 4,
        conditionField: "previous_investment",
        conditionOperator: "neq",
        conditionFieldValue: null,
      },
      message: "Maximum 100 Words Allowed.!",
      valid: true,
      changed: false,
    },
    signupfrom: {
      conditions: {
        required: true,
      },
      message: "This feild is required!",
      valid: true,
      changed: false,
    },

    // "Communication Preference":{
    //     conditions: {
    //         "required": true, "maxWordLength": 100,"delimiter":" ","conditionalRequired": true, "conditionValue": 4, "conditionField": "previous_investment", "conditionOperator": "neq","conditionFieldValue":null
    //     }, "message": "This feild is required!", "valid": true, "changed": false
    // },
  };
  const [validationState, setValidationState] = useState(validations);

  const reasonMapper = {
    1: "Requested for sign up but did not do it",
    2: "Left Abruptly",
    3: "Other reason",
  };
  const [formObject, setFromObject] = useState(form);

  // formObject.mobile.replace(/[\u202C\u200B-\u200D\uFEFF]/g ==> this line is for removing the non-printable characters like this u202C\u200B-\u200D (Pop Directional Formatting) character in your copied text example : '9849385658‬'.


  // let userQuestionnaire = [
  //     // { "lable": "Source Channel*", "filedType": "dropDown" },
  //     { "lable": "How did you get to know about Savart?", "imp":false, "filedType": "dropDown", "value": "enquiry", "display": true },
  //     { "lable": "Communication Preference", "imp":true, "filedType": "dropDown", "value": "communication", "display": true },
  //     { "lable": "Was he/ She interested in the services?", "imp":false, "filedType": "dropDown", "value": "interest", "display": true, "boolean": true },
  //     { "lable": "If not interested, what was the reason for disinterest?", "imp":false, "filedType": "text", "value": "reason_notinterest", "display": true ,disableCondition:"interest",disableValue:1 },
  //     { "lable": "Was he/ She polite with communication", "imp":false, "filedType": "dropDown", "value": "politeness", "display": true, "boolean": true },
  //     { "lable": "Family background", "imp":false, "filedType": "text", "value": "family_background", "display": true },
  //     { "lable": "Goal Details", "imp":false, "filedType": "text", "value": "goal", "display": true },
  //     { "lable": "Have you ever invested before?", "imp":false, "filedType": "dropDown", "value": "previous_investment", "display": true, "boolean": false },
  //     { "lable": "If yes, How was your experience?", "imp":false, "filedType": "text", "value": "inv_exp", "display": true,disableCondition:"previous_investment",disableValue:4 },
  //     { "lable": "If yes, with which broker? what was the quantum?", "imp":false, "filedType": "text", "value": "broker_quantum", "display": true,disableCondition:"previous_investment",disableValue:4 },
  //     { "lable": "If yes, with which adivisor? what was the quantum?", "imp":false, "filedType": "text", "value": "advisor_quantum", "display": true,disableCondition:"previous_investment",disableValue:4 },
  //     { "lable": "Status", "imp":false, "filedType": "dropDown", "value": "status", "display": false }
  //     // { "lable": "Prospect Location", "imp":false, "filedType": "dropDown" ,"value":"loc_country"},
  // ]
  const classes = useStyles();
  const validateMobile = (e) => {
    e.preventDefault();
    let mobileRegualr = /^[0-9\b]+$/;
    setmobileNumberDuplicate(false);
    // setmobileNumberLength(false)
    setmobileNumberPattern(false);
    setmobileTestPass(true);
    if (
      formObject.countrycode === "91" &&
      formObject.mobile.replace(/[\u202C\u200B-\u200D\uFEFF]/g, "").length !==
        10
    ) {
      setmobileNumberLength(true);
    } else {
      setmobileNumberLength(false);
    }
    if (
      formObject.mobile.length > 1 &&
      !mobileRegualr.test(
        Number(formObject.mobile.replace(/[\u202C\u200B-\u200D\uFEFF]/g, ""))
      )
    ) {
      setmobileNumberPattern(true);
      // setmobileTestPass(false);
    } else if (formObject.mobile.length >= 10) {
      http
        .get("/checkmobileemail?mobile=" + formObject.mobile)
        .then((resopnse) => {
          if (resopnse.data && resopnse.data.Data) {
            setmobileNumberDuplicate(true);
            // setmobileTestPass(false);
          }
        })
        .catch((error) => {});
    } else {
      // setmobileTestPass(false);
    }
  };
  const validateEmail = (e) => {
    e.preventDefault();
    let emailRegEx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setemailDuplicate(false);
    setemailPattern(false);
    setemailTestPass(true);
    if (formObject.email.length > 1 && !emailRegEx.test(formObject.email)) {
      setemailPattern(true);
      setemailTestPass(false);
    } else {
      http
        .get("/checkmobileemail?email=" + formObject.email)
        .then((resopnse) => {
          if (resopnse.data && resopnse.data.Data) {
            setemailDuplicate(true);
            setemailTestPass(false);
          }
        })
        .catch((error) => {});
    }
  };
  // (emailDuplicate, 'emailDuplicate');

  const [tagData, setTagData] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedRadioTags, setSelectedRadioTags] = useState([]);

  // console.log(selectedRadioTags, selectedTags);

  useEffect(() => {
    http
      .get("/add_prospect")
      .then((response) => {
        // (response.data.data[1]);
        setTaskType(response.data.rmnames);
        // (taskType);
        setQuestionner(response.data.data);
        let countryList = response.data.data.filter((obj) => {
          return obj.question === "Country";
        });
        if (
          countryList &&
          countryList.length > 0 &&
          countryList[0]["options"] &&
          Array.isArray(countryList[0]["options"])
        ) {
          setcountryDropDown(countryList[0]["options"]);
        }

        let languageList = response.data.data.filter((obj) => {
          return obj.question === "Communication Preference";
        });
        let prospectTypes = response.data.data.filter((obj) => {
          return obj.question === "Prospect Type";
        });
        if (
          prospectTypes &&
          prospectTypes.length > 0 &&
          prospectTypes[0]["options"] &&
          Array.isArray(prospectTypes[0]["options"])
        ) {
          setProspectType(prospectTypes[0]["options"]);
        }

        if (
          languageList &&
          languageList.length > 0 &&
          languageList[0]["options"] &&
          Array.isArray(languageList[0]["options"])
        ) {
          setLanguage(languageList[0]["options"]);
        }

        //
        // setFromObject(form)
      })
      .catch((error) => {});

    if (
      localStorage.getItem("empRole") === "MF Manager" ||
      localStorage.getItem("empRole") === "MF Executive" ||
      localStorage.getItem("empRole") === "Franchise"
    ) {
      updateValidations();
    }

    http
      .get(`customertags/0`)
      .then((res) => {
        setTagData(res.data.data.all_tags);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    setFromObject({
      ...formObject,
      selected_tags: [...selectedRadioTags, ...selectedTags].join(","),
    });
  }, [selectedTags, selectedRadioTags]);

  const handlePmsTag = (e, itemName) => {
    if (e.target.checked) {
      setSelectedTags((prevSelectedTags) => [...prevSelectedTags, itemName]);
    } else {
      // Remove the tag from the selectedTags array if unchecked
      setSelectedTags((prevSelectedTags) =>
        prevSelectedTags.filter((tag) => tag !== itemName)
      );
    }
  };

  const [showPMsOPtions, setShowPMSOptions] = useState(false);
  const toggleSelect = () => {
    setShowPMSOptions((val) => !val);
  };

  const handlePmsRadioTag = (e, itemName) => {
    // setSelectedRadioTags([e.target.value]);
    const input = document.getElementById(itemName);

    if (itemName === "PMS" && input.checked) {
      document.getElementById("PIA").checked = false;
      setSelectedRadioTags([e.target.value]);
    }
    if (itemName === "PIA" && input.checked) {
      document.getElementById("PMS").checked = false;
      setSelectedRadioTags([e.target.value]);
    }

    if (itemName === "PMS" && !input.checked) {
      setSelectedRadioTags([]);
    }

    if (itemName === "PIA" && !input.checked) {
      setSelectedRadioTags([]);
    }
  };
  console.log(formObject);
  const updateValidations = () => {
    setValidationState({
      ...validationState,
      type: {
        conditions: {
          required: false,
        },
        message: "This feild is required!",
        valid: true,
        changed: false,
      },
      signupfrom: {
        conditions: {
          required: false,
        },
        message: "This feild is required!",
        valid: true,
        changed: false,
      },
    });
  };

  const handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    let valid = true;
    let validStateTemp = { ...validationState };
    let validation = null;
    if (name && validStateTemp.hasOwnProperty(name)) {
      if (
        validStateTemp[name]["conditions"].hasOwnProperty(
          "conditionalRequired"
        ) &&
        validStateTemp[name]["conditions"].hasOwnProperty("conditionField") &&
        validStateTemp[name]["conditions"].hasOwnProperty(
          "conditionOperator"
        ) &&
        validStateTemp[name]["conditions"].hasOwnProperty("conditionValue") &&
        formObject.hasOwnProperty(
          validStateTemp[name]["conditions"]["conditionField"]
        )
      ) {
        validStateTemp[name]["conditions"]["conditionFieldValue"] =
          formObject[validStateTemp[name]["conditions"]["conditionField"]];
        validation = handleValidation(name, value, validStateTemp);
      } else {
        validation = handleValidation(name, value, validStateTemp);
      }

      setValidationState(validation.validStateTemp);
      valid = validation.valid;
    }
    if (valid || value === "" || value === 0) {
      let finalObjet = { ...formObject };
      finalObjet[name] = value;
      let validStateTemp = { ...validationState };
      let validData = handleSubmitValidation(finalObjet, validStateTemp);
      setValidationState(validData.validStateTemp);
      let setObject = { ...formObject };
      if (name === "previous_investment" && value === 4) {
        setObject["inv_exp"] = "";
        setObject["broker_quantum"] = "";
        setObject["advisor_quantum"] = "";
        setObject["previous_investment"] = value;
        setFromObject(setObject);
      } else {
        setFromObject({
          ...formObject,
          [event.target.name]: event.target.value,
        });

        // setFromObject({
        //     ...formObject,
        //     rm: event.target.value
        // });
      }
    }
  };
  console.log(selectedRadioTags.length, selectedTags.length, "length");
  const handleSubmit = (event) => {
    if (selectedRadioTags.length === 0 && selectedTags.length === 0) {
      setFromObject({
        ...formObject,
        selected_tags: "Untagged",
      });
    } else {
      setFromObject({
        ...formObject,
        selected_tags: [...selectedTags, ...selectedRadioTags].join(","),
      });
    }
    event.preventDefault();
    let validStateTemp = { ...validationState };
    let validCount = 0;
    let finalObjet = { ...formObject };

    if (
      localStorage.getItem("empRole") === "MF Manager" ||
      localStorage.getItem("empRole") === "MF Executive" ||
      localStorage.getItem("empRole") === "Franchise"
    ) {
      finalObjet.type = "Franchise";
    } else {
      finalObjet.type = finalObjet.type;
    }

    let validData = handleSubmitValidation(finalObjet, validStateTemp);
    validCount = validData.validCount;

    if (
      validCount === 0 &&
      emailPattern !== true &&
      mobileNumberPattern !== true &&
      mobileNumberDuplicate !== true &&
      mobileNumberLength !== true &&
      emailDuplicate !== true
    ) {
      // ('call api here');
      setFromObject({
        ...formObject,
        addProspectBtnClick: true,
      });
      // userQuestionnaire.map(obj => {
      //     let filter = []
      //     if (obj["filedType"] === "dropDown" && !obj['boolean']) {
      //         filter = questionner.filter(question => {
      //             return question.question === obj.lable
      //         })
      //         if (filter.length > 0) {
      //             let value = filter[0].options.filter(option => {
      //                 return option.values === finalObjet[obj.value]
      //             })
      //             if (value.length > 0) {
      //                 finalObjet[obj.value] = value[0]['name']
      //             }
      //         }

      //     }
      //     if (obj['boolean'] && finalObjet[obj.value] != 1) {
      //         finalObjet[obj.value] = 0
      //     }

      // })
      let statusObject = {
        Interested: "I",
        "Not Interested": "N",
        Later: "L",
        "No Answer": "O",
        "No Status": "S",
      };
      // finalObjet['status'] = finalObjet['status'] && finalObjet['status'].length > 0 && statusObject[finalObjet['status']] ? statusObject[finalObjet['status']] : "";
      // finalObjet['reason'] = reasonMapper[finalObjet['reason']]?reasonMapper[finalObjet['reason']]:null;
      Object.keys(finalObjet).map((key) => {
        finalObjet[key] = finalObjet[key] === "" ? null : finalObjet[key];
      });
      // delete finalObjet['addProspectBtnClick']
      http
        .post("/add_prospect", finalObjet)
        .then((response) => {
          if (response.data.statusCode === 0) {
            toast.success(response.data.data);
            history.goBack();
          } else {
            toast.error(response.data.data);
          }
          setFromObject({
            ...formObject,
            addProspectBtnClick: false,
          });
          // setFromObject(form)
        })
        .catch((error) => {});
    } else {
      setValidationState(validData.validStateTemp);
      // ('check errors');
      toast.error("Please check Errors in Field level!");
    }
  };
  return (
    <Grid container component="main" className={("overviewbar", "pb30")}>
      <Grid item xs={12} sm={5} md={5} className="pb30">
        <Button
          variant="outlined"
          color="default"
          startIcon={<ArrowBackIosIcon />}
          onClick={history.goBack}
        >
          Back
        </Button>
      </Grid>
      <Grid item xs={12} sm={5} md={5} className="pb30">
        <Typography color="textPrimary" variant="h5">
          Add New Prospect
        </Typography>
      </Grid>

      <Grid container className={classes.paper}>
        <Grid item xs={12} sm={5} md={5} className={"formLable"}>
          <InputLabel className={classes.lableColor} id="mobileCodeLable">
            {" "}
            Mobile Number{" "}
            <span
              style={{
                color: "red",
                fontSize: "1.2rem",
                marginLeft: "0.2rem",
              }}
            >
              *
            </span>
          </InputLabel>
        </Grid>
        <Grid
          item
          xs={3}
          sm={3}
          md={3}
          lg={3}
          xl={2}
          style={{ display: "flex" }}
        >
          {questionner
            .filter((obj) => {
              return obj.question === "CountryCodes";
            })
            .map((a) => {
              return (
                <Select
                  displayEmpty
                  labelId="mobileCodeLable"
                  id="mobileCodeLable"
                  variant="outlined"
                  onChange={handleChange}
                  value={formObject.countrycode ? formObject.countrycode : ""}
                  name="countrycode"
                  className={classes.select}
                >
                  <MenuItem value="">Select</MenuItem>
                  {a.options.map((option) => {
                    return (
                      <MenuItem value={option.country_code}>
                        {option.country_code}
                      </MenuItem>
                    );
                  })}
                  )
                </Select>
              );
            })}

          {/* <TextField id="standard-basic" label="Enter Mobile Number" variant="outlined" value={formObject.mobile} onChange={handleChange} name="mobile" onBlur={validateMobile}
                     style={validationState.hasOwnProperty("mobile")&&validationState["mobile"]['changed']&&!validationState["mobile"]['valid']?{paddingBottom:20}:{}}
                    error={(mobileNumberDuplicate || mobileNumberLength || mobileNumberPattern)||validationState.hasOwnProperty("mobile")&&validationState["mobile"]['changed']&&!validationState["mobile"]['valid']} 
                    helperText={mobileNumberDuplicate ? "Mobile number already exists!" : mobileNumberLength ? "Atleast 10 digits required!" : mobileNumberPattern ? "Numbers only Allowed!" :validationState.hasOwnProperty("mobile")&&validationState["mobile"]['changed']&&!validationState["mobile"]['valid']?validationState["mobile"]['message']:""}
                     /> */}
        </Grid>
        <Grid item xs={12} sm={3} md={3} lg={3}>
          <TextField
            id="standard-basic"
            label="Enter Mobile Number"
            variant="outlined"
            value={formObject.mobile}
            onChange={handleChange}
            name="mobile"
            onBlur={validateMobile}
            style={
              validationState.hasOwnProperty("mobile") &&
              validationState["mobile"]["changed"] &&
              !validationState["mobile"]["valid"]
                ? { paddingBottom: 20 }
                : {}
            }
            error={
              mobileNumberDuplicate ||
              mobileNumberLength ||
              mobileNumberPattern ||
              (validationState.hasOwnProperty("mobile") &&
                validationState["mobile"]["changed"] &&
                !validationState["mobile"]["valid"])
            }
            helperText={
              mobileNumberDuplicate
                ? "Mobile number already exists!"
                : mobileNumberLength
                ? "10 digits required!"
                : mobileNumberPattern
                ? "Numbers only Allowed!"
                : validationState.hasOwnProperty("mobile") &&
                  validationState["mobile"]["changed"] &&
                  !validationState["mobile"]["valid"]
                ? validationState["mobile"]["message"]
                : ""
            }
          />
        </Grid>
      </Grid>
      <Grid container className={classes.paper}>
        <Grid item xs={12} sm={5} md={5} className={"formLable"}>
          <InputLabel className={classes.lableColor} id="firstNameLable">
            First Name
          </InputLabel>
        </Grid>

        <Grid item xs={12} sm={5} md={5}>
          <TextField
            id="firstNameField"
            label="Enter"
            variant="outlined"
            name="fname"
            value={formObject.fname}
            onChange={handleChange}
            className={classes.select}
            style={
              validationState.hasOwnProperty("fname") &&
              validationState["fname"]["changed"] &&
              !validationState["fname"]["valid"]
                ? { paddingBottom: 20 }
                : {}
            }
            error={
              validationState["fname"]["changed"] &&
              !validationState["fname"]["valid"]
            }
            helperText={
              validationState["fname"]["changed"] &&
              !validationState["fname"]["valid"]
                ? validationState["fname"]["message"]
                : ""
            }
          />
        </Grid>
      </Grid>
      <Grid container className={classes.paper}>
        <Grid item xs={12} sm={5} md={5} className={"formLable"}>
          <InputLabel className={classes.lableColor} id="lastNameLable">
            Last Name
          </InputLabel>
        </Grid>

        <Grid item xs={12} sm={5} md={5}>
          <TextField
            id="lastNameField"
            label="Enter"
            variant="outlined"
            className={classes.select}
            name="lname"
            value={formObject.lname}
            onChange={handleChange}
            style={
              validationState.hasOwnProperty("lname") &&
              validationState["lname"]["changed"] &&
              !validationState["lname"]["valid"]
                ? { paddingBottom: 20 }
                : {}
            }
            error={
              validationState["lname"]["changed"] &&
              !validationState["lname"]["valid"]
            }
            helperText={
              validationState["lname"]["changed"] &&
              !validationState["lname"]["valid"]
                ? validationState["lname"]["message"]
                : ""
            }
          />
        </Grid>
      </Grid>
      <Grid container className={classes.paper}>
        <Grid item xs={12} sm={5} md={5} className={"formLable"}>
          <InputLabel className={classes.lableColor} id="emailIDLable">
            Email ID
          </InputLabel>
        </Grid>

        <Grid item xs={12} sm={5} md={5} className={"formLable"}>
          <TextField
            id="emailIDField"
            label="Enter"
            variant="outlined"
            style={
              validationState.hasOwnProperty("mobile") &&
              validationState["mobile"]["changed"] &&
              !validationState["mobile"]["valid"]
                ? { paddingBottom: 20 }
                : {}
            }
            className={classes.select}
            name="email"
            value={formObject.email}
            onChange={handleChange}
            onBlur={validateEmail}
            error={emailDuplicate || emailPattern}
            helperText={
              emailDuplicate
                ? "Email already exist"
                : emailPattern
                ? "Invalid Email!"
                : ""
            }
          />
          {/* //     helperText={emailDuplicate ? "Email already exists!" : emailPattern ? "Invalid Email!" : ""} /> */}
        </Grid>
      </Grid>

      {localStorage.getItem("empRole") === "MF Manager" ||
      localStorage.getItem("empRole") === "MF Executive" ||
      localStorage.getItem("empRole") === "Franchise" ? (
        ""
      ) : (
        <>
          <Grid container className={classes.paper}>
            <Grid item xs={12} sm={5} md={5} className={"formLable"}>
              <InputLabel className={classes.lableColor} id="emailIDLable">
                Prospect Type{" "}
                <span
                  style={{
                    color: "red",
                    fontSize: "1.2rem",
                    marginLeft: "0.2rem",
                  }}
                >
                  *
                </span>
              </InputLabel>
            </Grid>
            <Grid item xs={12} sm={5} md={5} className={"formLable"}>
              <select
                onChange={handleChange}
                className={classes.select}
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  height: "40px",
                }}
                value={formObject.type}
                name="type"
              >
                <option value="">Select</option>
                {prospectType.map((item) => {
                  return <option value={item.name}>{item.name}</option>;
                })}
              </select>
            </Grid>
          </Grid>

          <Grid container className={classes.paper}>
            <Grid item xs={12} sm={5} md={5} className={"formLable"}>
              <InputLabel className={classes.lableColor} id="emailIDLable">
                Prospect Source{" "}
                <span
                  style={{
                    color: "red",
                    fontSize: "1.2rem",
                    marginLeft: "0.2rem",
                  }}
                >
                  *
                </span>
              </InputLabel>
            </Grid>
            <Grid item xs={12} sm={5} md={5} className={"formLable"}>
              <select
                onChange={handleChange}
                className={classes.select}
                value={formObject.signupfrom}
                name="signupfrom"
              >
                <option value="">Select</option>
                {/* {prospectType.map((item) => {
                  return <option value={item.name}>{item.name}</option>;
                })} */}

                <option value="Call Request">Call Request</option>
                <option value="Refferal">Refferal</option>
                <option value="Revival">Revival</option>
                <option value="IVR Call">IVR Call</option>
                <option value="Renewal">Renewal</option>
                <option value="Chat Lead">Chat Lead</option>
                <option value="Franchise">Franchise</option>
                <option value="Dual Login">Dual Login</option>
              </select>
            </Grid>
          </Grid>
        </>
      )}

      <Grid container className={classes.paper}>
        <Grid item xs={12} sm={5} md={5} className={"formLable"}>
          <InputLabel className={classes.lableColor} id="emailIDLable">
            RM Name{" "}
            <span
              style={{
                color: "red",
                fontSize: "1.2rem",
                marginLeft: "0.2rem",
              }}
            >
              *
            </span>
          </InputLabel>
        </Grid>

        <Grid item xs={12} sm={5} md={5} className={"formLable"}>
          <select
            onChange={handleChange}
            className={classes.select}
            style={{
              border: "1px solid #ccc",
              borderRadius: "5px",
              height: "40px",
            }}
            value={formObject.rm}
            name="rm"
          >
            <option value="">Select</option>
            {taskType.map((item) => {
              return <option value={item.value}>{item.name}</option>;
            })}

            {/* <option></option>
                        <option></option> */}
          </select>
        </Grid>
      </Grid>

      <Grid container className={classes.paper}>
        <Grid item xs={12} sm={5} md={5} className={"formLable"}>
          <InputLabel className={classes.lableColor} id="emailIDLable">
            Communication Preference{" "}
            <span
              style={{
                color: "red",
                fontSize: "1.2rem",
                marginLeft: "0.2rem",
              }}
            >
              *
            </span>
          </InputLabel>
        </Grid>

        <Grid item xs={12} sm={5} md={5} className={"formLable"}>
          <select
            onChange={handleChange}
            className={classes.select}
            style={{
              border: "1px solid #ccc",
              borderRadius: "5px",
              height: "40px",
            }}
            value={formObject.language}
            name="language"
          >
            <option value="">Select</option>
            {language.map((item) => {
              return <option value={item.name}>{item.name}</option>;
            })}

            {/* <option></option>
                        <option></option> */}
          </select>
        </Grid>
      </Grid>

      <Grid container className={classes.paper}>
        <Grid item xs={12} sm={5} md={5} className={"formLable"}>
          <InputLabel className={classes.lableColor} id="emailIDLable">
            Tag
          </InputLabel>
        </Grid>

        <Grid item xs={12} sm={5} md={5} className={"formLable"}>
          <Button
            variant="outlined"
            onClick={toggleSelect}
            style={{
              borderRadius: "5px",
              minWidth: 235,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <p>Select Tag</p>{" "}
            <p>
              {!showPMsOPtions ? (
                <ArrowDropDown style={{ marginTop: 10 }} />
              ) : (
                <ArrowDropUp style={{ marginTop: 10 }} />
              )}
            </p>
          </Button>

          {showPMsOPtions && (
            <div style={{ marginTop: 15 }}>
              {tagData.map((item) => {
                return (
                  <label style={{ margin: "3px 0px", padding: 0 }}>
                    <input
                      // type={
                      //   item.name === "PIA" || item.name === "PMS"
                      //     ? "radio"
                      //     : "checkbox"
                      // }
                      type="checkbox"
                      // name={
                      //   item.name === "PIA" || item.name === "PMS"
                      //     ? "tag"
                      //     : item.name
                      // }
                      name={item.name}
                      id={item.name}
                      value={item.name}
                      onChange={
                        item.name === "PIA" || item.name === "PMS"
                          ? (e) => handlePmsRadioTag(e, item.name)
                          : (e) => handlePmsTag(e, item.name)
                      }
                    />{" "}
                    {item.name}
                  </label>
                );
              })}
            </div>
          )}
        </Grid>
      </Grid>
      {/* <Grid container className={classes.paper} >
                <Grid item xs={12} sm={5} md={5} className={"formLable"}>
                    <InputLabel className={classes.lableColor} id="q1Lable">Why did the prospect not sign up? <span style={{color: 'red', fontSize: '1.2rem', marginLeft: '0.2rem'}}>*</span></InputLabel>
                </Grid>

                <Grid item xs={12} sm={5} md={5} >
                    <FormControl component="fieldset" className={"formLable"}>
                        <RadioGroup row aria-label="position" name="reason"  value={(formObject.reason) ? formObject.reason : ""} onChange={handleChange}>
                            <FormControlLabel
                                control={<Radio classes={{ root: classes.radio, checked: classes.checked }} value="1" />}
                                label="Requested for sign up but did not do it"
                                labelPlacement="end"
                            />
                            <FormControlLabel
                                control={<Radio classes={{ root: classes.radio, checked: classes.checked }} value="2" />}
                                label="Left Abruptly"
                                labelPlacement="end"
                            />
                            <FormControlLabel
                                control={<Radio classes={{ root: classes.radio, checked: classes.checked }} value="3" />}
                                label="Other reason"
                                labelPlacement="end"
                            />
                        </RadioGroup>
                    </FormControl>
                </Grid>
            </Grid> */}
      {/* <Grid container className={classes.paper} >
                <Grid item xs={12} sm={5} md={5} className={"formLable"}>
                    <InputLabel className={classes.lableColor} id="datePickerLable">Get Back Date</InputLabel>
                </Grid>

                <Grid item xs={12} sm={5} md={5} >
                    <TextField
                        id="datePickerId"
                        label="Select Date"
                        type="date"
                        // defaultValue="07:30"
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,

                        }}
                        InputProps={{inputProps: { min:getToday() } }}
                        format="YYYY-MM-DD"
                        value={formObject.getbackdate}
                        onChange={handleChange}
                        name="getbackdate"
                        className={classes.select}
                    />
                </Grid>
            </Grid> */}
      {/* <Grid container className={classes.paper} >
                <Grid item lg={5} md={5} sm={5} className={"formLable"}>
                    <InputLabel className={classes.lableColor} id="statusLable">Status</InputLabel>
                </Grid>
                <Grid item lg={5} md={5} sm={5}>{
                    questionner.filter(obj => { return obj.question === "Status" }).map(a => {
                        return (<Select displayEmpty labelId="statusLable" id="statusSelect" variant="outlined" className={classes.select} onChange={handleChange} value={formObject.status} name="status">
                            <MenuItem value="">Select</MenuItem>
                            {a.options.map(option => {
                                return <MenuItem value={option.values}>{option.name}</MenuItem>
                            })}
                            )
                        </Select>)
                    })}

                </Grid>
            </Grid> */}
      {/* <Grid container className={classes.paper}>
                <Grid item lg={5} md={5} sm={5} xs={0}/>
                <Grid item lg={3} md={3} sm={3}>
                    <TextField
                        label="Enter Remarks"
                        multiline
                        rows={3}
                        variant="outlined"
                        value={formObject.comment}
                        onChange={handleChange}
                        name="comment"
                        className={classes.select}
                        error={validationState["comment"]['changed']&&!validationState["comment"]['valid']}
                        helperText={validationState["comment"]['changed']&&!validationState["comment"]['valid']?validationState["comment"]['message']:`${formObject.comment.length}/${validationState["comment"]["conditions"]['maxWordLength']}`}
                    />
                </Grid>
            </Grid> */}

      {/* <Grid container className={classes.gridDevider}>
                <Grid item xs={12} sm={5} md={5} >
                    <Typography color="textPrimary" variant="h5" >User Questionnaire</Typography>
                </Grid>
            </Grid> */}
      {/* {
                userQuestionnaire.map(question => {

                    return (question.display ?
                        <Grid container className={classes.paper} >
                            <Grid item xs={12} sm={5} md={5} className={"formLable"}>
                                <InputLabel className={classes.lableColor} id="statusLable">{question.lable}
                                    {question.imp && <span style={{color: 'red', fontSize: '1.2rem', marginLeft: '0.2rem'}}>*</span>}
                                </InputLabel>
                            </Grid>
                            <Grid item lg={5} md={5} sm={5} >
                                {question.filedType === "dropDown" ? (
                                    questionner.filter(obj => { return obj.question === question.lable }).map(a => {
                                        return (<><Select displayEmpty labelId="statusLable" id="statusSelect" variant="outlined" className={classes.select} onChange={handleChange} value={(formObject[question.value]) ? formObject[question.value] : ""} name={question.value}
                                        style={validationState.hasOwnProperty(question.value)&&validationState[question.value]['changed']&&!validationState[question.value]['valid']?{paddingBottom:20}:{}}
                                        error={validationState.hasOwnProperty(question.value)&&validationState[question.value]['changed']&&!validationState[question.value]['valid']} 
                                        >
                                            <MenuItem value="">Select</MenuItem>
                                            {a.options.map(option => {
                                                return <MenuItem value={option.values} key={option.values}>{option.name}</MenuItem>
                                            })}
                                            )
                                        </Select>{validationState.hasOwnProperty(question.value)
                                        &&validationState[question.value]['changed']&&
                                        !validationState[question.value]['valid']?
                                        <div style={{color:"#f44336",fontSize:"0.75rem",margin:"3px 14px" }}>{validationState[question.value]['message']}</div>:null}
                                        </>)
                                    })
                                ) : <TextField label="Enter" variant="outlined" value={formObject[question.value]} name={question.value} onChange={handleChange} className={classes.select} disabled={question.disableCondition&&formObject.hasOwnProperty(question.disableCondition)&&formObject[question.disableCondition]===question.disableValue}
                                style={validationState.hasOwnProperty(question.value)&&validationState[question.value]['changed']&&!validationState[question.value]['valid']?{paddingBottom:20}:{}}
                                error={validationState.hasOwnProperty(question.value)&&validationState[question.value]['changed']&&!validationState[question.value]['valid']} 
                                helperText={validationState.hasOwnProperty(question.value)&&validationState[question.value]['changed']&&!validationState[question.value]['valid']?validationState[question.value]['message']:""}
                                />}
                            </Grid>
                        </Grid> : ""
                    )
                })
            } */}
      {/* <Grid container className={classes.paper} >
                <Grid item xs={12} sm={5} md={5} className={"formLable"}>
                    <InputLabel className={classes.lableColor} id="locatonLable">Prospect Location</InputLabel>
                </Grid>

                <Grid item xs={12} sm={4} md={3} lg={3} className="mobileCodeLable">
                    <TextField id="standard-basic" label="State" variant="outlined" className={classes.select} value={formObject.loc_state} onChange={handleChange} name="loc_state" />
                </Grid>
                <Grid item xs={12} sm={3} md={3} >
                    <Select displayEmpty labelId="Country" id="Country" variant="outlined" className={classes.select} onChange={handleChange} value={(formObject.loc_country) ? formObject.loc_country : ""} name="loc_country">
                        <MenuItem value="">Select</MenuItem>
                        {countryDropDown.map(option => {
                            return <MenuItem value={option.locname}>{option.locname}</MenuItem>
                        })}
                        )
                    </Select>
                </Grid>
            </Grid> */}
      <Grid container className={classes.submitButton}>
        <Grid item xs={12} sm={5} md={5}></Grid>

        <Grid item xs={12} sm={2} md={2}>
          {/* {
                        formObject.addProspectBtnClick ? <Button variant="contained" color="primary" disabled className="addBtn">Add Prospect</Button>
                            : 
                    } */}
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            className="addBtn"
          >
            Add Prospect
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default AddProspect;
